export enum SpecialismCode {
    allergyAndImmunology = '0326',
    anesthesiology = '0389',
    audiology = '1900',
    cardiology = '0320',
    cardiothoracicSurgery = '0328',
    clinicalChemistry = '0386',
    dentalHygienists = '8700',
    dentalSpecialistsDentomaxillaryOrthopedics = '1300',
    dentistsOrGeneralPractitionerOrOther = '1200',
    dermatologyAndVenereology = '0310',
    dietitians = '2400',
    exerciseTherapistsUnspecified = '0700',
    gastroenterology = '0318',
    genetics = '0390',
    geriatrics = '0335',
    internalMedicine = '0313',
    medicalSpecialistsUnspecified = '0300',
    microbiology = '0387',
    neurology = '0330',
    neurosurgery = '0308',
    nuclearMedicine = '0363',
    nursesUnspecified = '9100',
    obstetricianUnspecified = '0800',
    obstetricsAndGynaecology = '0307',
    occupationalTherapists = '8800',
    ophthalmology = '0301',
    oralAndMaxillofacialSurgery = '1100',
    orthopaedics = '0305',
    otherDoctorsSCENDoctor = '8421',
    otorhinolaryngology = '0302',
    patalogy = '0388',
    pediatrics = '0316',
    physiotherapistsUnspecified = '0400',
    plasticSurgery = '0304',
    podiatrists = '2600',
    psychiatry = '0329',
    psychologicalCareUnspecified = '9400',
    pulmonology = '0322',
    radiology = '0362',
    radiotherapy = '0361',
    rehabilitation = '0327',
    rheumatology = '0324',
    speechTherapistsUnspecified = '0500',
    sportsMedicine = '8416',
    surgery = '0303',
    urology = '0306',
}

export function isSpecialismCode(value: string): value is SpecialismCode {
    return Object.values(SpecialismCode).includes(value as SpecialismCode);
}

export enum MedicalSpecialistSpecialismCode {
    allergyAndImmunology = '0326',
    anesthesiology = '0389',
    audiology = '1900',
    cardiology = '0320',
    cardiothoracicSurgery = '0328',
    clinicalChemistry = '0386',
    dermatologyAndVenereology = '0310',
    gastroenterology = '0318',
    genetics = '0390',
    geriatrics = '0335',
    internalMedicine = '0313',
    microbiology = '0387',
    neurology = '0330',
    neurosurgery = '0308',
    nuclearMedicine = '0363',
    obstetricsAndGynaecology = '0307',
    ophthalmology = '0301',
    oralAndMaxillofacialSurgery = '1100',
    orthopaedics = '0305',
    otorhinolaryngology = '0302',
    patalogy = '0388',
    pediatrics = '0316',
    plasticSurgery = '0304',
    psychiatry = '0329',
    pulmonology = '0322',
    radiology = '0362',
    radiotherapy = '0361',
    rehabilitation = '0327',
    rheumatology = '0324',
    sportsMedicine = '8416',
    surgery = '0303',
    urology = '0306',
}
